import getFilters from 'components/Filters';
import MentorshipStatusChip from 'components/Chips/MentorshipStatusChip';
import MENTORSHIP_STATUS from 'enums/MentorshipStatus';
import { FC, useContext } from 'react';
import useSWR from 'swr';
import MentorshipReferee from 'types/MentorshipReferee';
import { BinomesContext, TagColumnNames } from '..';

const mentorshipStatusTags = Object.keys(
  MENTORSHIP_STATUS,
) as (keyof typeof MENTORSHIP_STATUS)[];

const Filters = getFilters<TagColumnNames>();
const BinomesFilters: FC = () => {
  const { search, setSearch, tags, setTags, take, setTake } =
    useContext(BinomesContext);

  const { data: referees } = useSWR<MentorshipReferee[]>('/mentorship-referee');

  return (
    <Filters
      tagList={[
        {
          columnName: 'status',
          columnTitle: 'Statut du mentorat',
          tags: mentorshipStatusTags.map((tag) => ({
            name: tag,
            label: MENTORSHIP_STATUS[tag],
            labelComponent: <MentorshipStatusChip status={tag} />,
          })),
        },
        {
          columnName: 'referee',
          columnTitle: 'Chargée de mentorat',
          tags:
            referees?.map((referee) => ({
              name: referee.name || '',
              label: `(Chargée) ${referee.name}`,
              labelComponent: referee.name || '',
            })) || [],
        },
      ]}
      state={{ tags, search, take }}
      setTags={setTags}
      setSearch={setSearch}
      setTake={setTake}
    />
  );
};

export default BinomesFilters;